export var APP_GENERATE_SHORT_URL_START = 'APP_GENERATE_SHORT_URL_START';
export var APP_GENERATE_SHORT_URL_DONE = 'APP_GENERATE_SHORT_URL_DONE';
export var APP_GENERATE_SHORT_URL_FAIL = 'APP_GENERATE_SHORT_URL_FAIL';